module.exports = __webpack_public_path__ + "img/左上图标.149a1298.png";